import _ from "lodash";
import { Text, Title, Divider, Group, ThemeIcon, Badge } from "@mantine/core";
import React from "react";
import moment from "moment";
import InfoGridList from "./infoGridList";
import { useCellRender } from "../hooks/useCellRender";

import { IconClick, IconCash, IconHeart } from "@tabler/icons";
import { useTranslation } from "react-i18next";
import {
  formatDefaultPhoneDisplay,
  formatEmergencyPhoneDisplay,
} from "../helpers/userContactUtils";
export default function UserBasicInfo({ form }) {
  const [cellRender] = useCellRender();
  const user = form.values;
  const dataFontWeight = 600;

  const emptyStr = "-";
  const { t } = useTranslation();
  const fmt = (v) =>
    v === null || v === undefined || v === "" ? emptyStr : v;
  const fields = [
    {
      title: "User Category",
      value: user.userCategory ? t(user.userCategory) : emptyStr,
    },
    { title: "Staff Id", value: fmt(user.staffId) },
    { title: "Name", value: fmt(user.name) },
    { title: "Status", value: fmt(user.status) },

    { title: "Alias", value: fmt(user.aliasName) },
    { title: "Chinese Name", value: fmt(user.cname) },

    { title: "Gender", value: user.gender ? t(user.gender) : emptyStr },
    {
      title: "ID",
      value: user.hkid
        ? cellRender.Mask(user.hkid, "*", 4, 4, "end")
        : emptyStr,
    },

    { title: t("Phone"), value: fmt(formatDefaultPhoneDisplay(user)) },
    {
      title: t("Emergency Phone"),
      value: fmt(formatEmergencyPhoneDisplay(user)),
    },

    {
      title: "Date of Birth",
      value: user.birthday
        ? cellRender.Date(user.birthday, "YYYY-MM-DD")
        : emptyStr,
    },

    {
      title: "Education Level",
      value: user.educationLevel ? t(user.educationLevel) : emptyStr,
    },

    { title: "Marital Status", value: user.mariage ? t(user.mariage) : emptyStr },
    {
      title: "Teams",
      value: _.isEmpty(user.teams)
        ? emptyStr
        : user.teams?.map((team) => team.name).join(", "),
    },
    {
      title: "Refered By",
      value: fmt(user.referedBy?.name),
    },
  ];
  return user && <InfoGridList fields={fields} values={user} />;
}
